import styled from 'styled-components';

export const StyledContainer = styled.div`
  color: ${(props) => props.theme.newPalette.neutral.N800};
  margin: 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export const StyledHeader = styled.div`
  color: ${(props) => props.theme.newPalette.neutral.N800};
  ${(props) => props.theme.newTypography.textStyleDisplayMedium}
`;

export const StyledDescription = styled.div`
  color: ${(props) => props.theme.newPalette.neutral.N800};
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  margin-bottom: 9px;
`;
